import { useMemo } from 'react';
import { LICENSE_PRODUCTS } from '../actions/constants/LicenseProductConstant';

// prop 으로 받은 제품을 key 기준으로 고정 — 부모가 같은 key 의 새 객체를 넘겨도 effect 가 다시 돌지 않게 한다.
// 생략 → undefined(thunk 는 생략=SMARTDent). 목록 밖 key 는 { key } 그대로 넘겨 thunk 가 warn 후 fail-closed 하게 둔다.
export const useLicenseProduct = (product) => {
    const key = product?.key;
    return useMemo(() => {
        if (!key) return undefined;
        return LICENSE_PRODUCTS.find((p) => p.key === key) ?? { key };
    }, [key]);
};
